import { Injectable, ErrorHandler } from '@angular/core';
import { ApplicationInsightsService } from './application-insights/application-insights.service';

@Injectable()
export class AppInsightsErrorHandler implements ErrorHandler {
  constructor(private appInsights: ApplicationInsightsService) {}

  handleError(error: any): void {
    this.appInsights.trackException(error);
    console.error(error.message); // Optional: Log error to console as well
    
  }
}